import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getSchools } from "../../../ApiService/ApiService";
import SchoolTable from "./SchoolTable";
import AddSchool from "./AddSchool";
import { Add } from "@mui/icons-material";

function SchoolSection() {
  const [schools, setSchools] = useState({});
  const [showAddSchool, setShowAddSchool] = useState(false);
  const [loading, setLoading] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);

  useEffect(() => {
    fetchSchools();
  }, []);

  const fetchSchools = async () => {
    try {
      setLoading(true);
      const response = await getSchools();
      setSchools(response?.data);
    } catch (err) {
      console.error("Error fetching schools:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleActionClick = (actionComponent) => {
    setActionComponent(actionComponent);
  };

  const renderMainContent = () => {
    if (showAddSchool) {
      return (
        <AddSchool
          fetchSchools={fetchSchools}
          setShowAddSchool={setShowAddSchool}
        />
      );
    } else if (actionComponent) {
      return <Box>{actionComponent}</Box>;
    } else {
      return (
        <SchoolTable
          schools={schools}
          fetchSchools={fetchSchools}
          setActionComponent={setActionComponent}
          handleActionClick={handleActionClick}
        />
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddSchool || actionComponent ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Schools
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddSchool(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            marginBottom: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add School
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default SchoolSection;
